import { PortalTypeContext } from "./PortalTypeContext";
import useTrackPageView from "./hooks/useTrackPageView";

const TrackingProvider = (props) => {
  const { portal } = props;

  useTrackPageView({ portal });

  return (
    <PortalTypeContext.Provider value={portal}>
      {props.children}
    </PortalTypeContext.Provider>
  );
};

export default TrackingProvider;
